import "./css/site.css";
import "va/lib/css"

// Global css here
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs/css/dataTables.bootstrap.css";
import "admin-lte/dist/css/AdminLTE.css";
import "admin-lte/dist/css/skins/skin-black.css";
import "vue-upload-component/dist/vue-upload-component.part.css"
import "jquery.fancytree/dist/skin-vista/ui.fancytree.css";

// Custom css
import "./css/ah.mb.fancytree.css";
import "./css/datables-customizations.css";
import "./css/bootstrap-customizations.css";
import "./css/googlecharts-customizations.css";

import "admin-lte"

import Vue from "vue";

import VueRouter from 'vue-router';
Vue.use(VueRouter);

// Common js
import "bootstrap/dist/js/bootstrap";


// Third-party vue components
import * as uiv from "uiv"
Vue.use(uiv, { prefix: "uiv" });


import Vuex, {Store} from "vuex";
Vue.use(Vuex);

import { Component } from "vue-property-decorator";

import VueGridLayout from 'vue-grid-layout';

Vue.component("file-upload", require("vue-upload-component"));

Vue.component("grid-layout", VueGridLayout.GridLayout);
Vue.component("grid-item", VueGridLayout.GridItem);

import VueTagsInput from "@johmun/vue-tags-input";
//import VueTagsInput from '@johmun/vue-tags-input';
Vue.component("vue-tags-input", VueTagsInput);

//Vue.component("vue-tags-input", require("@johmun/vue-tags-input"));

// Register the router hooks with their names.  These are used in individual components
// to capture leaving without saving changes
Component.registerHooks([
    "beforeRouteLeave"
//    "beforeRouteEnter"

]);

// Vue component definitions go here
Vue.component("user-editor", require("./components/accounts/user-editor.vue.html"));
Vue.component("register-user-dialog", require("./components/accounts/register-user-dialog.vue.html"));
Vue.component("edit-user-dialog", require("./components/accounts/edit-user-dialog.vue.html"));
Vue.component("notification-editor", require("./components/notifications/notification-editor.vue.html"));
Vue.component("directory-node-info", require("./components/directory-node-info/directory-node-info.vue.html"));
Vue.component("new-model-editor", require("./components/new-model-editor/new-model-editor.vue.html"));
Vue.component("upload-model-dialog", require("./components/upload-model-dialog/upload-model-dialog.vue.html"));
Vue.component("import-model-tags-dialog", require("./components/import-model-tags-dialog/import-model-tags-dialog.vue.html"));
Vue.component("execute-script-dialog", require("./components/execute-script-dialog/execute-script-dialog.vue.html"));
Vue.component("select-commodity-dialog", require("./components/select-commodity-dialog/select-commodity-dialog.vue.html"));
Vue.component("new-model-node-dialog", require("./components/new-model-node-dialog/new-model-node-dialog.vue.html"));
Vue.component("search-and-replace-dialog", require("./components/search-and-replace-dialog/search-and-replace-dialog.vue.html"));
Vue.component("edit-node-data-dialog", require("./components/edit-node-data-dialog/edit-node-data-dialog.vue.html"));
Vue.component("search-and-replace-dialog", require("./components/search-and-replace-dialog/search-and-replace-dialog.vue.html"));
Vue.component("export-node-data-dialog", require("./components/export-node-data-dialog/export-node-data-dialog.vue.html"));
Vue.component("upload-node-data-dialog", require("./components/upload-node-data-dialog/upload-node-data-dialog.vue.html"));
Vue.component("report-carousel", require("./components/report-carousel/report-carousel.vue.html"));
Vue.component("report-editor", require("./components/report-editor-dialog/report-editor-dialog.vue.html"));
Vue.component("report-folder-editor-dialog", require("./components/report-folder-editor-dialog/report-folder-editor-dialog.vue.html"));
Vue.component("download-reports-dialog", require("./components/download-reports-dialog/download-reports-dialog.vue.html"));
Vue.component("report-editor-dialog", require("./components/report-editor-dialog/report-editor-dialog.vue.html"));
Vue.component("converge-model-dialog", require("./components/converge-model-dialog/converge-model-dialog.vue.html"));
Vue.component("convergence-graph", require("./components/convergence-graph/convergence-graph.vue.html"));
Vue.component("video-player", require("./components/video-player/video-player.vue.html"));
Vue.component("upload-attachment-dialog", require("./components/upload-attachment-dialog/upload-attachment-dialog.vue.html"));
Vue.component("recent-items-list", require("./components/recent-items-list/recent-items-list.vue.html"));
Vue.component("link-data-dialog", require("./components/link-data-dialog/link-data-dialog.vue.html"));
Vue.component("create-model-node-dialog", require("./components/create-model-node-dialog/create-model-node-dialog.vue.html"));
Vue.component("model-annotations-table", require("./components/model-annotations-table/model-annotations-table.vue.html"));
Vue.component("publish-to-dashboard-dialog", require("./components/publish-to-dashboard-dialog/publish-to-dashboard-dialog.vue.html"));
Vue.component("auto-tag-model-dialog", require("./components/auto-tag-model-dialog/auto-tag-model-dialog.vue.html"));
Vue.component("raw-node-editor", require("./components/raw-node-editor/raw-node-editor.vue.html"));
Vue.component("event-notifications-editor-dialog", require("./components/event-notifications-editor-dialog/event-notifications-editor-dialog.vue.html"));
Vue.component("model-scenario-chooser", require("./components/model-scenario-chooser/model-scenario-chooser.vue.html"));
Vue.component("download-model-dialog", require("./components/download-model-dialog/download-model-dialog.vue.html"));
Vue.component("strings-editor", require("./components/strings-editor/strings-editor.vue.html"));
Vue.component("export-network-diagram-dialog", require("./components/export-network-diagram-dialog/export-network-diagram-dialog.vue.html"));
Vue.component("distribute-diagram-nodes-dialog", require("./components/distribute-diagram-nodes-dialog/distribute-diagram-nodes-dialog.vue.html"));
Vue.component("network-diagram-options-dialog", require("./components/network-diagram-options-dialog/network-diagram-options-dialog.vue.html"));
Vue.component("paste-nodes-options-dialog", require("./components/paste-nodes-options-dialog/paste-nodes-options-dialog.vue.html"));
Vue.component("ai-assistant", require("./components/ai-assistant/ai-assistant.vue.html"));


Vue.component("dashboard-datasets-dialog", require("./components/dashboard-datasets-dialog/dashboard-datasets-dialog.vue.html"));
Vue.component("publish-to-dashboard-options", require("./components/publish-to-dashboard-options/publish-to-dashboard-options.vue.html"));
var dashboardListComponent = Vue.component("dashboard-list", require("./components/dashboard-list/dashboard-list.vue.html"));
var modelDashboardComponent = Vue.component("dashboard", require("./components/dashboard/dashboard.vue.html"));
var embeddedDashboardComponent = Vue.component("embedded-dashboard", require("./components/embedded-dashboard/embedded-dashboard.vue.html"));

var modelViewerComponent = Vue.component("model-viewer", require("./components/model-viewer/model-viewer.vue.html"));
var modelReportsComponent = Vue.component("model-reports", require("./components/model-reports/model-reports.vue.html"));
var convergenceMonitorComponent = Vue.component("convergence-monitor",
    require("./components/convergence-monitor/convergence-monitor.vue.html"));
var modelValidationComponent = Vue.component("model-validation",
    require("./components/model-validation/model-validation.vue.html"));

// Vue routes definitions go here

const routes = [

    { path: "/", component: require("./components/home/home.vue.html"), meta: { title: "Home" } },
    { path: "/contact", component: require("./components/contact/contact.vue.html") },
    { path: "/about", component: require("./components/about/about.vue.html")},
    { path: "/admin", component: require("./components/admin/admin-index.vue.html") },

    // Accounts
    { path: "/admin/accounts", component: require("./components/accounts/accounts-index.vue.html") },

    { path: "/admin/db", component: require("./components/db-admin/db-admin-index.vue.html") },
    { path: "/admin/convergence", component: require("./components/convergence-admin/convergence-admin-index.vue.html") },
    { path: "/admin/notifications", component: require("./components/notifications/notifications-admin.vue.html") },
    { path: "/admin/modellocks", component: require("./components/model-locks/model-locks-admin.vue.html") },
    { path: "/admin/siteinfo", component: require("./components/site-info/site-info.vue.html") },
    { path: "/admin/tag-categories", component: require("./components/tag-categories/tag-categories.vue.html") }, 

    // Help
    { path: "/help", component: require("./components/help/help-index.vue.html") },

    // Model directory
    {
        path: "/models",
        component: require("./components/model-directory/model-directory.vue.html")
    },

    // Model validation
    {
        path: "/models/validation/:modelId",
        name: "model-validation",
        component: modelValidationComponent,
        props: true
    },

    // Model editor
    {
        path: "/models/editor/:modelId/:rootNode?/:targetSector?",
        name: "model-editor",
        component: modelViewerComponent,
        props: true
    },

    // Model reports
    {
        path: "/models/reports/:modelId",
        name: "model-reports",
        component: modelReportsComponent,
        props: true
    },

    // Convergence monitor
    {
        path: "/convergence/monitor",
        name: "convergence-monitor",
        component: convergenceMonitorComponent
    },

    // Convergence watcher
    {
        path: "/convergence/watch/:jobId",
        name: "convergence-watcher",
        component: require("./components/convergence-watcher/convergence-watcher.vue.html"),
        props: true
    },

    // Model Dashboard
    {
        path: "/models/dashboard/:modelId/:scenarioName?",
        name: "model-dashboard",
        component: modelDashboardComponent,
        props: true
    },

    // Dashboard list
    {
        path: "/dashboard-list",
        name: "dashboard-list",
        component: dashboardListComponent,
//        props: true
    },

    // Embedded Dashboard
    {
        path: "/embedded-dashboard/:dashboardId",
        name: "embedded-dashboard",
        component: embeddedDashboardComponent,
        props: true
    },

    // Command log
    {
        path: "/models/commandlog/:modelId",
        name: "model-command-log",
        component: require("./components/model-command-log/model-command-log.vue.html"),
        props: true
    },


    // 404
    //{path: '*', name: '404', component: require("./components/404-page/404.vue.html")}
    ];



// Nav menu
Vue.component("nav-menu", require("./components/nav-menu/nav-menu.vue.html"));


// TESTING
//Vue.component("model-viewer", require("./components/model-viewer/model-viewer.vue.html"))

var router =
    new VueRouter({ mode: "history", routes: routes });


/**
 * Set document title based on route's meta
 */
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? `ArrowHead Modeling Platform: ${to.meta.title}` : "ArrowHead Modeling Platform";
    next();
});


import * as StoreTypes from "./infrastructure/state/state-store";
import * as StateTypes from "./infrastructure/state/state-types";

var theStore = new Vuex.Store<StateTypes.IRootState>(StoreTypes.store);

new Vue({
    el: "#app-root",
    store: theStore,
    router: router,
    render: h => h(require("./components/app/app.vue.html"))
});

Vue.config.devtools = true;

// Setup client notifier to handle command responses
import { ClientNotifier } from "./scripts/ah.mb.client-notifications";
var globalNotifier = new ClientNotifier();

// Global handler to show default responses to ajax requests
$(document).ajaxComplete((e, jqxhr) => {
    //alert("should not be in here ");
    //globalNotifier.globalResponseHandler(jqxhr);
});

/**
 * Convenience function for applying tooltips (v-tooltip)
 */
Vue.directive('tooltip', function (el, binding) {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    });
    $(el).attr("data-original-title", binding.value);
})



// WEBPACK FOOTER //
// ./ClientApp/boot.ts